import { isAtradiusRefused } from "../utils/atradiusRefusal";
import ClientAtradiusWarning from "./clients/ClientAtradiusWarning";
import ClientPricing from "./clients/ClientPricing";
import ClientOverdueWarning from "./clients/ClientOverdueWarning";
import ClientProspects from "./clients/ClientProspects";
import ClientTabHeading from "./clients/ClientTabHeading";
import "./clients/clientDetail.css";
import PlanningPage from "./rh/PlanningPage";
import ClientHistory from "./clients/ClientHistory";
import ContactPermissionBadges from "./clients/ContactPermissionBadges";
import PageHeading from "../components/PageHeading";
import ContactRolePermissions from "./clients/ContactRolePermissions";
import { clientContactPermissions, clientContactAccessMatrix, getEffectiveClientContactAccess, retireClientContact } from "../utils/clientContactPermissions";
import { formatPhone } from "../utils/formatPhone";
import ContractPage from "./contract/ContractPage";
import EditClientInfoForm from "./clients/EditClientInfoForm";
import FacturesPage from "./FacturesPage";
import RegistrePersonnel from "./rh/RegistrePersonnel";
import InterviewsSection from "./candidate/InterviewsSection";
import { Link } from "react-router-dom";
import { pricingMultiplier } from "../utils/quotationPricing";
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Building, User, Mail, Phone, MapPin, Calendar, FileText, MessageSquare, Shield, Users, Plus, Edit, Eye, Download, Clock, CheckCircle2, AlertCircle, CreditCard, Briefcase, Target, Loader2, UserCheck, Folder, Ban, DollarSign } from "lucide-react";
import axios from "../axios/AxiosInstance";
import { Modal, Popconfirm, message } from "antd";
import ClientComment from "./ClientComment";
import ClientDocuments from "./ClientDocuments";
import CreateQuotationModal from "./CreateQuotationModal";
import CreateContract from "./CreateContract/CreateContract";
import jsPDF from "jspdf";
import cgvClient from "../assets/img/img/cgv-client.jpg";
import myImage from "../assets/img/img/logopdf.png";
import logotoulouse from "../assets/img/img/logotoulouse.png";
import logobrive from "../assets/img/img/logobrive.png";
import gmail from "../assets/img/img/gmail.png";
import phone from "../assets/img/img/phone.png";

//import CreateContract from './CreateContract'
//import ClientModalContract from './ClientModalContract'
//import DuplicateContract from './DuplicateContract'
const clientInfoColors = {
  blue: { card: "border-blue-200 border-t-blue-500 from-blue-50", icon: "bg-blue-100 text-blue-700" },
  teal: { card: "border-teal-200 border-t-teal-500 from-teal-50", icon: "bg-teal-100 text-teal-700" },
  emerald: { card: "border-emerald-200 border-t-emerald-500 from-emerald-50", icon: "bg-emerald-100 text-emerald-700" },
  violet: { card: "border-violet-200 border-t-violet-500 from-violet-50", icon: "bg-violet-100 text-violet-700" },
  amber: { card: "border-amber-200 border-t-amber-500 from-amber-50", icon: "bg-amber-100 text-amber-800" },
};

const ClientInfoCard = ({ icon: Icon, title, children, color = "blue", className = "" }) => (
  <section className={`min-w-0 rounded-xl border border-t-4 bg-gradient-to-b to-white p-5 ${clientInfoColors[color].card} ${className}`}>
    <h3 className="mb-4 flex items-center gap-3 text-base font-semibold text-slate-900">
      <span className={`rounded-lg p-2 ${clientInfoColors[color].icon}`}><Icon size={18} /></span>
      {title}
    </h3>
    {children}
  </section>
);

const ClientInfoRow = ({ label, value, mono = false }) => (
  <div className="grid grid-cols-1 gap-1 py-3 sm:grid-cols-[minmax(0,1fr)_minmax(0,1.4fr)] sm:gap-4">
    <dt className="text-sm text-slate-500">{label}</dt>
    <dd className={`min-w-0 break-words text-sm font-medium ${value === null || value === undefined || value === "" ? "text-slate-400" : "text-slate-900"} ${mono ? "font-mono" : ""}`}>
      {value ?? "Non renseigné"}{value === "" ? "Non renseigné" : ""}
    </dd>
  </div>
);

const formatClientAddress = (address, postCode, town) =>
  [address, [postCode, town].filter(Boolean).join(" ")].filter(Boolean).join(", ");

const ClientDetail = ({
  client,
  setClient,
  clients,
  setClients,
  originalClients,
  initialSection = "info",
}) => {
  const [section, setSection] = useState(initialSection);
  const [editingClient, setEditingClient] = useState(false);
    const [updateContactObject, setUpdateContactObject] = useState({});
  
    const [quotations, setQuotations] = useState([]);
  const [, setOriginalQuotations] = useState([]);
  const [isOpenCreateContact, setIsOpenCreateContact] = useState(false);
  const [savingContact, setSavingContact] = useState(false);
  const [editingContactIndex, setEditingContactIndex] = useState(null);
    const [, setCanCreateContrat] = useState(false);
        const [isCreatePldContract, setIsCreatePldContract] = useState(false);
  const [clientQualifications, setClientQualifications] = useState([]);
  const [clientChantiers, setClientChantiers] = useState([]);
  const [isAskAtradius, setIsAskAtradius] = useState(false);
  const [isLoadingAtradius, setIsLoadingAtradius] = useState(false);
      const [cover, setCover] = useState(null);
  const [, setLoadedCover] = useState(false);
  const [amount, setAmount] = useState("");
  const [isCreateQuotation, setIsCreateQuotation] = useState(false);
  const [isLoadingQuotation, setIsLoadingQuotation] = useState(false);

  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key !== "Escape") return;
      // Let nested forms and document viewers handle Escape first.
      if (editingClient || isOpenCreateContact || isAskAtradius || isCreatePldContract || isCreateQuotation) return;
      const nestedDialog = Array.from(document.querySelectorAll('[role="dialog"]'))
        .some((dialog) => dialog.getAttribute("aria-labelledby") !== "client-detail-title" && dialog.getClientRects().length > 0);
      if (nestedDialog || event.defaultPrevented) return;
      setClient(null);
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [setClient, editingClient, isOpenCreateContact, isAskAtradius, isCreatePldContract, isCreateQuotation]);

  useEffect(() => {
    loadQuotations(client._id);
    loadQualifications();
    getCover();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadQualifications = () => {
    if (!client.pld) {
      setCanCreateContrat(false);
      console.log("pas de pld");
      return;
    }
    axios
      .get(`client/qualifications/${client.pld}`)
      .then((res) => {
        console.log(res.data);
        if (res.data.length > 0) {
          setCanCreateContrat(true);
          setClientQualifications(res.data.TabQualifications);
          setClientChantiers(res.data.TabChantiers);
        }
      })
      .catch((e) => console.log(e));
  };

  const getCover = () => {
    axios
      .get(`cover/client/${client._id}`)
      .then((res) => {
        console.log(res.data);
        setCover(Array.isArray(res.data) ? res.data[0] || null : res.data || null);
      })
      .catch((e) => {
        console.log(e);
      })
      .finally(() => setLoadedCover(true));
  };

  const loadQuotations = (clientId) => {
    axios
      .get(`quotation/by-client/${clientId}`)
      .then((res) => {
        const quotations = res.data.sort(
          (a, b) => b.quotationNumber - a.quotationNumber,
        );
        setQuotations(quotations);
        setOriginalQuotations(quotations);
        console.log(res.data);
      })
      .catch((e) => {
        message.error("erreur");
      });
  };

  const episList = [
    "Gants",
    "Lunette",
    "Protection",
    "Blouse",
    "Bleu",
    "Chaussures",
    "Auditive",
    "Casque",
    "Harnais",
    "Gilet",
    "Autre..",
  ];

  episList.map((epi) => {
    return {
      title: epi,
      value: epi,
      key: epi,
    };
  });

  
  const generatePDF = (quotation, viewOnly = false) => {
    setIsLoadingQuotation(true);

    try {
    // Fallbacks pour éviter les 500/crashes PDF quand l'objet devis
    // (souvent créé côté admin) n'a pas tous les champs peuplés.
    const defaultAgency = {
      name: "J'M INTERIM",
      address: "4 Avenue Laurent Cély, Hall A",
      postCode: "92600",
      town: "Asnières sur Seine",
      siret: "91912551800010",
      tva: "FR52919125518",
      email: "contact@jm-interim.com",
      phone: "01 80 88 21 35",
    };
    const agency = quotation.agency || defaultAgency;
    const client = quotation.client || {};
    const products = Array.isArray(quotation.products) ? quotation.products : [];
    const mainProduct = products[0]?.product || "";

    const pdf = new jsPDF({
      unit: "mm",
      format: [210, 297],
    });

    const img = new Image();
    if (agency.name === "CAPENEO") {
      img.src = logotoulouse;
      pdf.addImage(img, "PNG", 14, 10, 40, 24);
    } else if (agency.name === "J'M CAPENEO") {
      img.src = logobrive;
      pdf.addImage(img, "PNG", 24, 14, 32, 24);
    } else {
      img.src = myImage;
      pdf.addImage(img, "PNG", 14, 10, 40, 24);
    }

    const gmailImg = new Image();
    gmailImg.src = gmail;

    const phoneImg = new Image();
    phoneImg.src = phone;

    pdf.setFontSize(14);
    pdf.setFont("Helvetica", "Bold");
    pdf.text(agency.name || "AGENCE", 24, 45);
    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    pdf.text(agency.address || "", 15, 50);
    pdf.text((agency.postCode || "") + " " + (agency.town || ""), 15, 55);
    pdf.text("SIRET  : " + (agency.siret || ""), 15, 60);
    pdf.text("TVA n° : " + (agency.tva || agency.TVA || ""), 15, 65);
    pdf.addImage(gmailImg, "PNG", 15, 67, 3, 3);

    pdf.text(" : " + (agency.email || ""), 18, 69.5);
    pdf.addImage(phoneImg, "PNG", 15, 71.5, 3, 3);
    pdf.text(" : " + (agency.phone || ""), 18, 74);
    const creatorFirst = quotation.creator?.firstname || "";
    const creatorLast = quotation.creator?.lastname || "";
    if (creatorFirst || creatorLast) {
      pdf.text("Contact : " + creatorFirst + " " + creatorLast, 15, 79.5);
    }

    pdf.setFontSize(14);
    pdf.setFont("Helvetica", "Bold");
    if (quotation.quotationNumber && !quotation.isDraft) {
      pdf.text(
        "Devis n° " +
          formatJsDate2(quotation.createdAt) +
          "-" +
          quotation.quotationNumber.toString().padStart(5, 0),
        110,
        45,
      );
    } else {
      pdf.text("Devis provisoire", 110, 45);
    }

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");

    pdf.text("Date : ", 110, 50);
    pdf.text(formatJsDate(quotation.createdAt), 120, 50);
    if (quotation.expiryDate) {
      pdf.text("Date d'expiration :", 110, 55);
      pdf.text(formatJsDate(quotation.expiryDate), 137, 55);
    }

    pdf.setFontSize(10);
    pdf.setFont("Helvetica", "Bold");
    pdf.text("Adresse de facturation :", 15, 95);

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    const addressFacturation = (quotation.addressFacturation ?? "")
      .toString()
      .trim();
    const addressMatch = addressFacturation.match(/^(.*?)\b(\d{5})\b(.*)$/);
    var [partieAvant, codePostal, partieApres] = addressMatch
      ? addressMatch.slice(1).map((str) => str.trim())
      : [addressFacturation, "", ""];
    try {
      pdf.text(partieAvant || addressFacturation, 15, 100);
      if (codePostal || partieApres) {
        pdf.text(codePostal + " " + partieApres, 15, 105);
      }
    } catch (e) {
      console.log(e);
    }

    pdf.setFontSize(12);
    pdf.setFont("Helvetica", "Bold");
    const companyName = (
      client.companyName ||
      client.denomination ||
      "CLIENT"
    ).toUpperCase();
    const companyNameArray = splitStringWithoutCuttingWords(companyName, 30);
    let companyY = 80 - (companyNameArray.length - 1) * 5;
    for (let name of companyNameArray) {
      pdf.text(name, 110, companyY);
      companyY += 5;
    }

    pdf.setFontSize(9);
    pdf.setFont("Helvetica", "normal");
    // On retire email (@) et téléphone (chiffres) pour n'afficher que le nom.
    const contact = (quotation.contact ?? "")
      .toString()
      .split(" ")
      .filter((part) => part && !part.includes("@") && !/\d/.test(part))
      .join(" ")
      .trim();
    pdf.text(contact.toUpperCase(), 110.5, 85);
    pdf.text(partieAvant || addressFacturation, 110.5, 90);
    if (codePostal || partieApres) {
      pdf.text(codePostal + " " + partieApres, 110.5, 95);
    }
    pdf.text("SIRET : " + (client.siret || ""), 110.5, 100);
    pdf.text("TVA : " + (client.TVA || client.tva || ""), 110.5, 105);

    pdf.setFontSize(12);
    pdf.setFont("Helvetica", "bold");
    pdf.setTextColor(9, 132, 227);
    pdf.setDrawColor(9, 132, 227);

    // Vacation affiché comme Placement (aligné admin).
    if (mainProduct === "Placement" || mainProduct === "Vacation") {
      pdf.roundedRect(26, 115, 160, 30, 1, 1);
      pdf.text(mainProduct.toUpperCase(), 95, 120);
      pdf.line(95, 122, 122, 122);

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);

      pdf.text(
        "Vous nous mandatez pour recruter au sein de votre entreprise, un poste en CDD ou CDI.",
        46,
        130,
      );
      pdf.text(
        "Le contrat, la DPAE et la fiche de paie sont établis par vos soins. Vous êtes l'employeur.",
        46,
        135,
      );
      pdf.text("Vous recevrez une seule facture pour le placement", 57, 140);
    }

    if (
      mainProduct === "Délégation" ||
      mainProduct === "Gestion"
    ) {
      pdf.roundedRect(15, 110, 92, 35, 1, 1);
      pdf.roundedRect(110, 110, 92, 35, 1, 1);
      pdf.text("DELEGATION", 47, 115);
      pdf.line(47, 117, 75, 117);
      pdf.text("GESTION", 145, 115);
      pdf.line(145, 117, 164, 117);

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);

      pdf.text("Vous nous mandatez pour", 17, 125);
      pdf.setFont("Helvetica", "bold");
      pdf.text("recruter", 55, 125);
      pdf.setFont("Helvetica", "normal");
      pdf.text("   et", 65, 125);
      pdf.setFont("Helvetica", "bold");
      pdf.text("  gérer", 70, 125);
      pdf.setFont("Helvetica", "normal");
      pdf.text(" l'administratif", 80, 125);
      pdf.text("de ", 17, 130);
      pdf.setFont("Helvetica", "bold");
      pdf.text("notre", 21, 130);
      pdf.setFont("Helvetica", "normal");
      pdf.text("recrue. Le contrat, la DPAE et la fiche de paie sont", 30, 130);
      pdf.text(
        "établis par nous, qui sommes l'employeur. Vous avez à charge",
        17,
        135,
      );
      pdf.text(
        "la sécurité du salarié. Vous recevrez une facture mensuelle.",
        17,
        140,
      );

      pdf.text("Vous nous mandatez pour", 112, 125);
      pdf.setFont("Helvetica", "bold");
      pdf.text("gérer", 150, 125);
      pdf.setFont("Helvetica", "normal");
      pdf.text("simplement l'administratif", 159, 125);
      pdf.text("de", 112, 130);
      pdf.setFont("Helvetica", "bold");
      pdf.text("votre", 116, 130);
      pdf.setFont("Helvetica", "normal");
      pdf.text(
        "recrue. Le contrat, la DPAE et la fiche de paie sont",
        125,
        130,
      );
      pdf.text(
        "établis par nous, qui sommes l'employeur. Vous avez à charge",
        112,
        135,
      );
      pdf.text(
        "la sécurité du salarié. Vous recevrez une facture mensuelle.",
        112,
        140,
      );
    }

    pdf.setTextColor(0, 0, 0);

    pdf.setFillColor(9, 132, 227);
    pdf.setDrawColor(9, 132, 227);
    pdf.rect(15, 155, 180, 10, "F");

    pdf.setTextColor(255, 255, 255);
    pdf.setFontSize(10);
    pdf.setFont("Helvetica", "bold");

    if (
      mainProduct === "Délégation" ||
      mainProduct === "Gestion"
    ) {
      let height = 170;

      pdf.text("Designation", 25, 161);
      pdf.text("Taux horaire", 60, 161);
      pdf.text("Coefficient", 95, 161);
      pdf.text("Prix HT/heure", 130, 159);
      pdf.text("travaillée", 135, 163);
      pdf.text("Observation", 165, 161);

      pdf.setFontSize(10);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);
      pdf.setDrawColor(0, 0, 0);

      products.forEach((product, idx) => {
        const primeTypes = [
          "Prime",
          "Indemnité",
          "Prime Ségur",
          "Primes diverses",
          "Autre",
        ];
        if (primeTypes.includes(product.type) && product.type !== "Autre") {
          const prime = splitStringWithoutCuttingWords(
            product.type + " : " + (product.product || ""),
            24,
          );
          for (let i = 0; i < prime.length; i++) {
            pdf.text(prime[i], 20, height);
            height += 5;
          }
          height -= 5;
        } else if (product.type === "Autre") {
          pdf.text(product.product || "", 20, height);
        } else {
          pdf.text((product.product || "") + " H/F", 20, height);
          const poste = splitStringWithoutCuttingWords(product.poste || "", 24);
          for (let i = 0; i < poste.length; i++) {
            pdf.text(poste[i], 20, height + 5);
            height += 5;
          }
        }
        const hasTaux = product.taux !== "" && product.taux != null;
        const hasCoeff =
          pricingMultiplier(product) > 0;
        if (hasTaux) {
          pdf.text(parseFloat(product.taux).toFixed(2) + "€", 65, height);
        }
        if (hasCoeff) {
          pdf.text(String(pricingMultiplier(product)), 105, height);
        }
        if (hasTaux && hasCoeff) {
          pdf.text(
            (
              parseFloat(product.taux) * pricingMultiplier(product)
            ).toFixed(2) + "€",
            140,
            height,
          );
        }
        const commentLines = splitStringWithoutCuttingWords(
          product.comment || "",
          24,
        );
        for (let i = 0; i < commentLines.length; i++) {
          pdf.text(commentLines[i], 165, height);
          if (i < commentLines.length - 1) height += 5;
        }
        height += 5;
        pdf.setTextColor(128, 128, 128);
        pdf.setDrawColor(128, 128, 128);
        if (product.minimumHours) {
          pdf.text(
            "Nombre d'heures minimales avant embauche sans facturation : " +
              product.minimumHours +
              "h",
            50,
            height,
          );
          height += 3;
        }

        if (idx === products.length - 1) {
          pdf.setDrawColor(0, 0, 0);
          pdf.setLineWidth(0.5);
        }
        pdf.line(15, height, 195, height);
        pdf.setTextColor(0, 0, 0);
        pdf.setDrawColor(0, 0, 0);
        height += 7;
        if (height > 260) {
          pdf.addPage();
          height = 10;
        }
      });

      height += 10;
      if (height > 250) {
        pdf.addPage();
        height = 10;
      }

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");

      pdf.text("Nom et qualité du signataire :", 15, height);
      pdf.text("Date : " + formatJsDate(new Date()), 15, height + 5);

      pdf.text(String(client.tvaRate || ""), 120, height);
      pdf.text(
        "Conditions de paiement : " + (client.facturation || ""),
        120,
        height + 5,
      );
      pdf.text("Moyen de règlement : Virement/Chèque/CB", 120, height + 10);
    }

    if (mainProduct === "Placement" || mainProduct === "Vacation") {
      let height = 170;

      pdf.text("Designation", 25, 161);
      pdf.text("Quantité", 68, 161);
      pdf.text("PU (HT)", 110, 161);
      pdf.text("Montant (HT)", 160, 161);

      pdf.setFontSize(10);
      pdf.setFont("Helvetica", "normal");
      pdf.setTextColor(0, 0, 0);
      pdf.setDrawColor(0, 0, 0);

      products.forEach((product, idx) => {
        pdf.text((product.product || "") + " H/F", 20, height);
        pdf.text(product.poste || "", 20, height + 5);
        height += 5;
        const taux = parseFloat(product.taux);
        const coeff = pricingMultiplier(product);
        const safeTaux = Number.isFinite(taux) ? taux : 0;
        const safeCoeff = Number.isFinite(coeff) ? coeff : 0;
        pdf.text(safeTaux.toFixed(2) + "€", 110, height);
        pdf.text(String(pricingMultiplier(product)), 75, height);
        pdf.text((safeTaux * safeCoeff).toFixed(2) + "€", 175, height);
        height += 5;
        pdf.setTextColor(128, 128, 128);
        pdf.setDrawColor(128, 128, 128);

        if (idx === products.length - 1) {
          pdf.setDrawColor(0, 0, 0);
          pdf.setLineWidth(0.5);
        }
        pdf.line(15, height, 195, height);
        pdf.setTextColor(0, 0, 0);
        pdf.setDrawColor(0, 0, 0);
        height += 7;
        if (height > 260) {
          pdf.addPage();
          height = 10;
        }
      });

      if (height > 250) {
        pdf.addPage();
        height = 10;
      }

      pdf.setFillColor(135, 177, 255);
      pdf.setDrawColor(9, 132, 227);
      height += 6;
      pdf.setTextColor(255, 255, 255);
      pdf.setFont("Helvetica", "Bold");

      pdf.setTextColor(0, 0, 0);
      pdf.setFont("Helvetica", "normal");

      const totalHt = products.reduce((total, item) => {
        const t = parseFloat(item.taux);
        return total + (Number.isFinite(t) ? t : 0);
      }, 0);

      pdf.text("Total HT", 110, height);
      pdf.text(totalHt.toFixed(2) + " €", 174, height);

      height += 10;

      pdf.text((totalHt * 0.2).toFixed(2) + " €", 174, height);
      height += 10;
      pdf.setFillColor(9, 132, 227);
      pdf.rect(105, height - 7, 90, 10, "F");
      pdf.setTextColor(255, 255, 255);
      pdf.text("Total TTC", 110, height);
      pdf.text((totalHt * 1.2).toFixed(2) + " €", 174, height);

      pdf.setTextColor(0, 0, 0);

      height += 10;

      if (height >= 270) pdf.addPage();

      pdf.setFontSize(9);
      pdf.setFont("Helvetica", "normal");

      if (height > 280) {
        pdf.addPage();
        height = 10;
      }

      const firstProduct = products[0] || {};
      const paymentCondition = splitStringWithoutCuttingWords(
        "Conditions de paiement : " + (firstProduct.comment || ""),
        70,
      );
      const replaceCondition = splitStringWithoutCuttingWords(
        "Conditions de remplacement : " + (firstProduct.comment2 || ""),
        70,
      );
      pdf.text("Nom et qualité du signataire :", 15, height);
      pdf.text("Date : " + formatJsDate(new Date()), 15, height + 5);

      pdf.text("Moyen de règlement : Virement/Chèque/CB", 90, height);
      for (let x of paymentCondition) {
        pdf.text(x, 90, height + 5);
        height += 5;
        if (height >= 280) {
          pdf.addPage();
          height = 10;
        }
      }
      for (let x of replaceCondition) {
        pdf.text(x, 90, height + 10);
        height += 10;
        if (height >= 280) {
          pdf.addPage();
          height = 10;
        }
      }
    }

    pdf.text(
      `J'm intérim - SAS au capital de 80 000 € - 4 Avenue Laurent Cély, Hall A, 92600 Asnières sur Seine, France`,
      25,
      280,
    );
    pdf.text(
      "SIRET : 91912551800010 - Code APE : 7820z - N° de TVA : FR52919125518",
      50,
      285,
    );

    pdf.addPage();
    pdf.addImage(cgvClient, "PNG", 10, 10, 198, 282);

    const pdfBlob = pdf.output("blob");
    const pdfUrl = URL.createObjectURL(pdfBlob);

    if (viewOnly) {
      // Pour la visualisation, ouvrir dans un nouvel onglet
      window.open(pdfUrl, "_blank");
    } else {
      // Pour le téléchargement, déclencher le téléchargement
      const link = document.createElement("a");
      link.href = pdfUrl;
      link.download = `Devis_${quotation.quotationNumber || 'Provisoire'}_${formatJsDate2(quotation.createdAt)}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      // Libérer l'URL après le téléchargement
      setTimeout(() => URL.revokeObjectURL(pdfUrl), 1000);
    }
    } catch (e) {
      console.error("Erreur génération PDF devis:", e);
      message.error("Impossible d'afficher ce devis. Vérifiez les données du devis.");
    } finally {
      setIsLoadingQuotation(false);
    }
  };

  const atradiusValues = ["Accepté", "Refusé", "En arbitrage"];

  atradiusValues.map((atradiusValue) => {
    return {
      value: atradiusValue,
      label: atradiusValue,
    };
  });

  
  
  function splitStringWithoutCuttingWords(inputString, chunkSize) {
    const words = String(inputString ?? "").split(" ");
    const resultChunks = [];
    let currentChunk = "";

    for (const word of words) {
      if (currentChunk.length + word.length <= chunkSize) {
        currentChunk += (currentChunk ? " " : "") + word;
      } else {
        if (currentChunk) resultChunks.push(currentChunk);
        currentChunk = word;
      }
    }

    if (currentChunk) {
      resultChunks.push(currentChunk);
    }

    return resultChunks;
  }

  const formatJsDate2 = (date) => {
    const newDate = new Date(date);
    String(newDate.getDate()).padStart(2, "0");
    const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
    const year = newDate.getFullYear();

    return `${month}${year}`;
  };

  const retireContact = (contacts, idx) => {
    if (savingContact || contacts[idx]?.active === false) return;
    setSavingContact(true);
    const newContacts = retireClientContact(contacts, idx);
    axios
      .patch(`client/${client._id}`, { contacts: newContacts })
      .then((res) => {
        setUpdateContactObject({});
        const clientIdx = originalClients.findIndex(
          (c) => c._id === client._id,
        );
        const newClients = [...originalClients];
        if (clientIdx >= 0) newClients[clientIdx] = res.data;
        setClient(res.data);
        setClients(newClients);
        message.success("Contact retiré : son historique est conservé.");
        setIsOpenCreateContact(false);
      })
      .catch((e) => {
        message.error("Le contact n’a pas pu être enregistré. Réessayez.");
      })
      .finally(() => setSavingContact(false));
  };

  const formatJsDate = (date) => {
    const newDate = new Date(date);
    const day = String(newDate.getDate()).padStart(2, "0");
    const month = String(newDate.getMonth() + 1).padStart(2, "0"); // Months are 0-based, so we add 1
    const year = newDate.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const createPldContract = () => setIsCreatePldContract(true);

  const updateContacts = (event) => {
    event?.preventDefault();
    if (savingContact) return;
    if (!updateContactObject.lastname?.trim()) { message.error("Veuillez renseigner le nom du contact."); return; }
    setSavingContact(true);
    const savedContact = Object.fromEntries(Object.entries(updateContactObject).map(([key, value]) => [key, typeof value === "string" ? value.trim() : value]));
    if (savedContact.accessRights) {
      savedContact.accessRights = Object.fromEntries(clientContactAccessMatrix.map(([key]) => [key, getEffectiveClientContactAccess(savedContact, key)]));
    }
    const contacts = editingContactIndex === null
      ? [...(client.contacts || []), savedContact]
      : (client.contacts || []).map((contact, index) => index === editingContactIndex ? { ...contact, ...savedContact } : contact);
    axios
      .patch(`client/${client._id}`, {
        contacts,
      })
      .then((res) => {
        setUpdateContactObject({});
        const clientIdx = originalClients.findIndex(
          (c) => c._id === client._id,
        );
        const newClients = [...originalClients];
        if (clientIdx >= 0) newClients[clientIdx] = res.data;
        setClient(res.data);
        setClients(newClients);
        message.success(editingContactIndex === null ? "Contact créé !" : "Contact modifié !");
        setIsOpenCreateContact(false);
      })
      .catch((e) => {
        message.error("Le contact n’a pas pu être enregistré. Réessayez.");
      })
      .finally(() => setSavingContact(false));
  };

  const askAtradius = (event) => {
    event?.preventDefault();
    if (isLoadingAtradius) return;
    if (!client.siret) {
      message.error("Le client doit avoir un numero de siret");
      return;
    }
    if (!Number.isInteger(Number(amount)) || Number(amount) <= 0) {
      message.error("Veuillez saisir un montant entier supérieur à zéro.");
      return;
    }
    const siren = String(client.siret).replace(/\s/g, "").substring(0, 9);
    setIsLoadingAtradius(true);
    axios
      .post("cover/new-cover", { amount, siren, clientId: client._id })
      .then((res) => {
        console.log(res);
        message.success("La demande de cote a été envoyée.");
        setIsAskAtradius(false);
        setAmount("");
        getCover();
      })
      .catch((e) => {
        console.log(e);
        message.error("Une erreur s'est produite !");
      })
      .finally(() => {
        setIsLoadingAtradius(false);
      });
  };

  
  const formatDate = (dateString) => {
    if (!dateString) return "Non renseigné";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "Date invalide";
    }

    return new Intl.DateTimeFormat("fr-FR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };

  const formatAmount = (amount, decimals = 0) => {
    if (amount === "" || amount === null || amount === undefined) {
      return "Non renseigné";
    }

    const numAmount = parseFloat(amount);
    if (isNaN(numAmount)) {
      return "Non renseigné";
    }

    return decimals > 0 ? numAmount.toFixed(decimals) : numAmount.toLocaleString();
  };

  const hasPld = client.pld != null && String(client.pld).trim() !== "";
  const primaryContact = Array.isArray(client.contacts) ? client.contacts.find((contact) => contact.active !== false) : null;
  const contactName = [client.contactFirstname, client.contactLastname].filter(Boolean).join(" ") || [primaryContact?.firstname, primaryContact?.lastname].filter(Boolean).join(" ");
  const contactEmail = client.contactEMail || primaryContact?.email;
  const contactPhone = client.contactPhone || primaryContact?.mobile || primaryContact?.phone;

  const contactForm = (
                <form onSubmit={updateContacts} className="mt-5">
                  <fieldset disabled={savingContact}>
                    <legend className="mb-4 text-xs font-semibold uppercase tracking-wider text-blue-700">Identité et fonction</legend>
                    <div className="mb-4 w-32"><label htmlFor="contact-title" className="mb-2 block text-sm font-medium text-slate-700">Civilité</label><select id="contact-title" value={updateContactObject.title || ""} onChange={e => setUpdateContactObject({ ...updateContactObject, title: e.target.value })} className="h-11 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"><option value="">Choisir</option><option value="M.">M.</option><option value="Mme">Mme</option></select></div>
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                      {[{ key: "firstname", label: "Prénom", placeholder: "Ex. : Marie", autocomplete: "given-name" }, { key: "lastname", label: "Nom", placeholder: "Ex. : Dupont", autocomplete: "family-name", required: true }, { key: "profession", label: "Fonction dans l’entreprise", placeholder: "Ex. : Responsable RH", autocomplete: "organization-title", full: true }].map(field => <div key={field.key} className={field.full ? "sm:col-span-2" : ""}><label htmlFor={`contact-${field.key}`} className="mb-2 block text-sm font-medium text-slate-700">{field.label}{field.required && <span className="ml-1 text-blue-600">*</span>}</label><input id={`contact-${field.key}`} autoComplete={field.autocomplete} required={field.required} value={updateContactObject[field.key] || ""} onChange={e => setUpdateContactObject({ ...updateContactObject, [field.key]: e.target.value })} placeholder={field.placeholder} className="h-11 w-full rounded-lg border border-slate-200 bg-slate-50 px-3 text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" /></div>)}
                    </div>
                    <div className="mb-4 mt-6 border-t border-slate-100 pt-5 text-xs font-semibold uppercase tracking-wider text-blue-700">Coordonnées</div>
                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                      {[{ key: "phone", label: "Téléphone fixe", type: "tel", placeholder: "01 23 45 67 89", icon: Phone }, { key: "mobile", label: "Téléphone mobile", type: "tel", placeholder: "06 12 34 56 78", icon: Phone }, { key: "email", label: "Email professionnel", type: "email", placeholder: "marie@entreprise.fr", icon: Mail, full: true }].map(field => <div key={field.key} className={field.full ? "sm:col-span-2" : ""}><label htmlFor={`contact-${field.key}`} className="mb-2 block text-sm font-medium text-slate-700">{field.label}</label><div className="relative"><field.icon size={16} aria-hidden="true" className="absolute left-3 top-3.5 text-slate-400" /><input id={`contact-${field.key}`} type={field.type} autoComplete={field.type === "email" ? "email" : "tel"} value={updateContactObject[field.key] || ""} onChange={e => setUpdateContactObject({ ...updateContactObject, [field.key]: e.target.value })} placeholder={field.placeholder} className="h-11 w-full rounded-lg border border-slate-200 bg-slate-50 pl-10 pr-3 text-sm focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500" /></div></div>)}
                    </div>
                    <div className="mt-6 rounded-xl border border-violet-100 bg-violet-50/60 p-4">
                      <h3 className="text-sm font-semibold text-slate-900">Habilitations</h3>
                      <p className="mt-1 text-xs text-slate-500">Choisissez les documents que ce contact peut gérer.</p>
                      <ContactRolePermissions contact={updateContactObject} onAccessChange={(key, value) => setUpdateContactObject((current) => ({ ...current, accessRights: { ...current.accessRights, [key]: value } }))} onAllAccessChange={(value) => setUpdateContactObject((current) => ({ ...current, accessRights: Object.fromEntries(clientContactAccessMatrix.map(([key]) => [key, value])) }))} />
                    </div>
                  </fieldset>
                  <div className="mt-6 flex flex-wrap items-center justify-between gap-3 border-t border-slate-100 pt-5"><p className="text-xs text-slate-400">* Champ obligatoire</p><div className="flex gap-2"><button type="button" disabled={savingContact} onClick={() => setIsOpenCreateContact(false)} className="rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-medium text-slate-600 hover:bg-slate-50 disabled:opacity-50">Annuler</button><button type="submit" disabled={savingContact} className="inline-flex items-center gap-2 rounded-lg bg-blue-700 px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-800 disabled:opacity-60">{savingContact ? <><Loader2 size={16} className="animate-spin" />Enregistrement…</> : <><CheckCircle2 size={16} />{editingContactIndex === null ? "Ajouter le contact" : "Enregistrer"}</>}</button></div></div>
                </form>
  );

  return (
    <AnimatePresence>
      {client && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
        >
          <motion.div
            initial={{ scale: 0.9, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            exit={{ scale: 0.9, opacity: 0 }}
            role="dialog" aria-modal="true" aria-labelledby="client-detail-title"
            className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl h-[90vh] overflow-hidden flex flex-col"
          >
            <header className="shrink-0 border-b border-slate-200 bg-white px-5 py-4 sm:px-8">
              <div className="flex items-start justify-between gap-4">
                <div className="flex min-w-0 items-center gap-3">
                  <div className="flex h-16 w-16 shrink-0 items-center justify-center rounded-xl bg-blue-50 text-blue-700"><Building size={28} /></div>
                  <div className="min-w-0"><div className="flex flex-wrap items-center gap-2"><h1 id="client-detail-title" className="break-words text-2xl font-bold text-slate-900">{client.companyName || client.denomination}</h1><ClientOverdueWarning client={client} onClick={() => setSection("invoices")} /><ClientAtradiusWarning cover={cover} onClick={() => setSection("financial")} /><span className={`rounded-full px-2.5 py-1 text-xs font-semibold ${hasPld ? "bg-emerald-50 text-emerald-700" : "bg-orange-50 text-orange-700"}`}>{hasPld ? "Client" : "Prospect"}</span></div><p className="mt-2 text-xs text-slate-500">SIRET : {client.siret || "—"}{hasPld && ` · PLD : ${client.pld}`} · {[client.postCode, client.town].filter(Boolean).join(" ") || "Ville non renseignée"}</p></div>
                </div>
                <button aria-label="Fermer la fiche client" onClick={() => setClient(null)} className="shrink-0 rounded-lg p-2 text-slate-400 hover:bg-slate-100 hover:text-slate-700"><X size={22} /></button>
              </div>
              <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-2 text-xs">
                {contactName && <span className="inline-flex items-center gap-2 font-medium text-slate-700"><User size={15} className="text-slate-400" />{contactName}</span>}
                {contactPhone && <a href={`tel:${String(contactPhone).replace(/[^+0-9]/g, "")}`} className="inline-flex items-center gap-2 text-blue-700 hover:underline"><Phone size={15} />{formatPhone(contactPhone)}</a>}
                {contactEmail && <a href={`mailto:${contactEmail}`} className="inline-flex max-w-full items-center gap-2 text-blue-700 hover:underline"><Mail size={15} className="shrink-0" /><span className="break-all">{contactEmail}</span></a>}
                {!contactPhone && !contactEmail && <button onClick={() => setSection("contact")} className="text-blue-700 hover:underline">Compléter les coordonnées du contact</button>}
              </div>

            </header>
            <div className="flex min-h-0 flex-1">
              <div className="flex min-h-0 min-w-0 flex-1 flex-col">
                {/* Tabs Navigation */}
                <div className="shrink-0 bg-slate-50 border-b border-slate-200 px-3 overflow-x-auto">
                  <div className="flex min-w-max">
                    {[
                      { id: "info", label: "Informations", icon: Building },
                      { id: "contact", label: "Contacts", icon: Users },
                      { id: "event", label: "Historique", icon: Calendar },
                      { id: "prospects", label: "Pressenti", icon: UserCheck },
                      { id: "devis", label: "Devis", icon: FileText },
                      { id: "financial", label: "Atradius", icon: Shield },
                      { id: "file", label: "Fichiers", icon: Folder },
                      { id: "commentaire", label: "Commentaires", icon: MessageSquare },
                      { id: "contracts", label: "Contrats", icon: Briefcase },
                      { id: "planning", label: "Planning", icon: Calendar },
                      { id: "invoices", label: "Factures", icon: CreditCard },
                      { id: "pricing", label: "Tarif commercial", icon: DollarSign },
                      { id: "blocked", label: "Bloqués", icon: Ban },
                      { id: "register", label: "Registre du personnel", icon: Users },
                      { id: "interviews", label: "Entretiens", icon: Calendar },
                    ].map((tab) => {
                      const Icon = tab.icon;
                      return (
                        <motion.button
                          key={tab.id}
                          whileHover={{ y: -2 }}
                          aria-pressed={section === tab.id}
                          onClick={() => setSection(tab.id)}
                          className={`flex shrink-0 items-center space-x-2 px-3 py-3 text-sm font-medium border-b-2 transition-all duration-200 whitespace-nowrap ${
                            section === tab.id
                              ? "border-blue-600 text-blue-600 bg-white"
                              : "border-transparent text-slate-600 hover:text-slate-900 hover:border-slate-300"
                          }`}
                        >
                          <Icon className="w-4 h-4" />
                          <span>{tab.label}</span>
                        </motion.button>
                      );
                    })}
                  </div>
                </div>

                {/* Tab Content */}
                <div className="client-tab-content min-h-0 flex-1 overflow-y-auto bg-white p-4 sm:p-6 text-sm">
                  {/* Informations Tab */}
                  {section === "contracts" && <ContractPage key={client._id} audience="client" client={client} embedded onCreateContract={createPldContract} />}
                  {section === "prospects" && <ClientProspects key={client._id} client={client} />}
                  {section === "pricing" && <ClientPricing key={client._id} client={client} />}
                  {section === "blocked" && <ClientProspects key={`blocked-${client._id}`} client={client} blocked />}
                  {section === "interviews" && <InterviewsSection client={client} />}
                  {section === "planning" && <PlanningPage key={client._id} client={client} embedded />}
                  {section === "register" && <RegistrePersonnel key={client._id} client={client} embedded />}
                  {section === "invoices" && <FacturesPage key={client._id} client={client} embedded />}
                  {section === "info" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-4"
                    >
                      <div className="flex flex-wrap items-center justify-between gap-3">
                        <div>
                        <ClientTabHeading title="Informations du client" description="Coordonnées, identité et conditions commerciales." />
                        </div>
                        {!editingClient && <button type="button" onClick={() => setEditingClient(true)} className="inline-flex items-center gap-2 rounded-lg bg-blue-700 px-4 py-2 text-sm font-semibold text-white hover:bg-blue-800"><Edit size={16} />Modifier</button>}
                      </div>
            {editingClient ? (
              <EditClientInfoForm
                client={client}
                onClose={() => setEditingClient(false)}
                onSaved={(updatedClient) => {
                  const records = originalClients || clients || [];
                  const updatedRecords = records.some((record) => record._id === updatedClient._id)
                    ? records.map((record) => record._id === updatedClient._id ? updatedClient : record)
                    : [...records, updatedClient];
                  setClients(updatedRecords);
                  setClient(updatedClient);
                }}
              />
            ) : (<>
                      <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
                        <ClientInfoCard icon={User} title="Contact principal">
                          <p className="text-base font-semibold text-slate-900">{contactName || "Contact à compléter"}</p>
                          <div className="mt-4 space-y-3 text-sm">
                            {contactPhone ? <a className="flex items-center gap-3 text-blue-700 hover:underline" href={`tel:${String(contactPhone).replace(/[^+0-9]/g, "")}`}><Phone size={16} className="shrink-0" />{formatPhone(contactPhone)}</a> : <p className="text-slate-400">Téléphone non renseigné</p>}
                            {contactEmail ? <a className="flex items-center gap-3 text-blue-700 hover:underline" href={`mailto:${contactEmail}`}><Mail size={16} className="shrink-0" /><span className="break-all">{contactEmail}</span></a> : <p className="text-slate-400">Email non renseigné</p>}
                          </div>
                        </ClientInfoCard>
                        <ClientInfoCard icon={MapPin} title="Adresses" color="teal">
                          <dl className="divide-y divide-slate-100">
                            <ClientInfoRow label="Siège social" value={formatClientAddress(client.address, client.postCode, client.town)} />
                            <ClientInfoRow label="Livraison" value={formatClientAddress(client.addressLivraison || client.address, client.postCodeLivraison || client.postCode, client.townLivraison || client.town)} />
                            <ClientInfoRow label="Facturation" value={formatClientAddress(client.addressFacturation || client.address, client.postCodeFacturation || client.postCode, client.townFacturation || client.town)} />
                          </dl>
                        </ClientInfoCard>
                      </div>
                      <div className="grid grid-cols-1 gap-4 xl:grid-cols-3">
                        <ClientInfoCard icon={Building} title="Identité légale" color="emerald">
                          <dl className="divide-y divide-slate-100">
                            <ClientInfoRow label="SIRET" value={client.siret} mono />
                            <ClientInfoRow label="Code APE" value={client.APE || client.ape} />
                            <ClientInfoRow label="TVA intracom." value={client.TVA} />
                          </dl>
                        </ClientInfoCard>
                        <ClientInfoCard icon={CreditCard} title="Conditions commerciales" color="violet">
                          <dl className="divide-y divide-slate-100">
                            <ClientInfoRow label="Paiement" value={client.facturation} />
                            <ClientInfoRow label="Taux de TVA" value={client.tvaRate} />
                          </dl>
                        </ClientInfoCard>
                        <ClientInfoCard icon={Target} title="Suivi commercial" color="amber">
                          <dl className="divide-y divide-slate-100">
                            <ClientInfoRow label="Commercial" value={client.commercial || "Non assigné"} />
                            <ClientInfoRow label="Acquisition" value={client.clientAcquisition} />
                          </dl>
                        </ClientInfoCard>
                      </div>
                      </>)}
                    </motion.div>
                  )}

                  {/* Contacts Tab */}
                  {section === "contact" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-4"
                    >
                      <div className="flex items-center justify-between">
                        <ClientTabHeading title="Contacts" description="Consultez les interlocuteurs du client et leurs habilitations." />
                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={() => { setEditingContactIndex(null); setUpdateContactObject({ habilitations: [] }); setIsOpenCreateContact(true); }}
                          className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
                        >
                          <Plus className="w-4 h-4" />
                          <span>Ajouter un contact</span>
                        </motion.button>
                      </div>



                      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                        <div className="overflow-x-auto">
                          <table className="min-w-full divide-y divide-slate-200">
                            <thead className="bg-slate-50">
                              <tr>
                                <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                  Contact
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                  Poste
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                  Email
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                  Téléphone
                                </th>
                                <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">Habilitations</th>
                                <th className="px-6 py-4 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            <tbody className="bg-white divide-y divide-slate-200">
                              {client.contacts && client.contacts.length > 0 ? (
                                client.contacts
                                  .map((contact, index) => ({ contact, index }))
                                  .sort((a, b) => Number(a.contact.active === false) - Number(b.contact.active === false))
                                  .map(({ contact, index }) => (
                                  <motion.tr
                                    key={index}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.1 }}
                                    className="hover:bg-slate-50 transition-colors duration-200"
                                  >
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="flex items-center">
                                        <div className="bg-slate-100 p-2 rounded-lg mr-3">
                                          <User className="w-4 h-4 text-slate-600" />
                                        </div>
                                        <div>
                                          <div className="text-sm font-medium text-slate-900">
                                            {contact.title} {contact.firstname} {contact.lastname}
                                            {contact.active === false && <span className="ml-2 rounded-full bg-slate-100 px-2 py-1 text-xs text-slate-500">Parti</span>}
                                          </div>
                                        </div>
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm text-slate-900">{contact.profession || "Non renseigné"}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm text-slate-900">{contact.email || "Non renseigné"}</div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm text-slate-900">{formatPhone(contact.mobile || contact.phone) || "Non renseigné"}</div>
                                    </td>
                                    <td className="px-6 py-4"><ContactPermissionBadges contact={contact} /></td>
                                    <td className="px-6 py-4 whitespace-nowrap text-center">
                                      <div className="flex items-center justify-center space-x-2">
                                        <motion.button
                                          whileHover={{ scale: 1.1 }}
                                          whileTap={{ scale: 0.9 }}
                                          className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200"
                                          onClick={() => { setEditingContactIndex(index); setUpdateContactObject({ ...contact, habilitations: Array.isArray(contact.habilitations) ? contact.habilitations : clientContactPermissions.map((permission) => permission.value) }); setIsOpenCreateContact(true); }}
                                          title="Modifier"
                                          aria-label="Modifier le contact"
                                          disabled={savingContact}
                                        >
                                          <Edit className="w-4 h-4" />
                                        </motion.button>
                                        <Popconfirm
                                          title="Ce contact a quitté l’entreprise ?"
                                          description="Il sera marqué « Parti » et ne sera plus proposé pour les nouveaux documents. Son historique sera conservé."
                                          onConfirm={() => retireContact(client.contacts, index)}
                                          okText="Marquer comme parti"
                                          cancelText="Annuler"
                                          disabled={savingContact || contact.active === false}
                                          overlayStyle={{ maxWidth: 360 }}
                                        >
                                        <motion.button
                                          whileHover={{ scale: 1.1 }}
                                          whileTap={{ scale: 0.9 }}
                                          disabled={savingContact || contact.active === false}
                                          className="p-2 text-amber-600 hover:text-amber-700 hover:bg-amber-50 rounded-lg transition-all duration-200 disabled:opacity-40"
                                          title="Retirer le contact (départ)"
                                          aria-label="Retirer le contact (départ)"
                                        >
                                          <AlertCircle className="w-4 h-4" />
                                        </motion.button>
                                        </Popconfirm>
                                      </div>
                                    </td>
                                  </motion.tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="6" className="px-6 py-12 text-center">
                                    <div className="flex flex-col items-center">
                                      <Users className="w-12 h-12 text-slate-300 mb-4" />
                                      <h3 className="text-lg font-medium text-slate-900 mb-2">Aucun contact</h3>
                                      <p className="text-slate-500">Commencez par ajouter un contact pour ce client</p>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </motion.div>
                  )}

                  {/* Devis Tab */}
                  {section === "devis" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-4"
                    >
                      <div className="flex items-center justify-between">
                        <ClientTabHeading title="Devis" description="Retrouvez les devis du client et leur suivi commercial." />
                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={() => setIsCreateQuotation(true)}
                          className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
                        >
                          <Plus className="w-4 h-4" />
                          <span>Nouveau devis</span>
                        </motion.button>
                      </div>

                      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                        {quotations && quotations.length > 0 ? (
                          <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-slate-200">
                              <thead className="bg-slate-50">
                                <tr>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Numéro
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Date
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Expiration
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Montant
                                  </th>
                                  <th className="px-6 py-4 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Actions
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white divide-y divide-slate-200">
                                {quotations.map((quotation, index) => (
                                  <motion.tr
                                    key={quotation._id || index}
                                    initial={{ opacity: 0, y: 20 }}
                                    animate={{ opacity: 1, y: 0 }}
                                    transition={{ delay: index * 0.1 }}
                                    className="hover:bg-slate-50 transition-colors duration-200"
                                  >
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm font-medium text-slate-900">
                                        #{quotation.quotationNumber || "Provisoire"}
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm text-slate-900">
                                        {formatDate(quotation.createdAt)}
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm text-slate-900">
                                        {formatDate(quotation.expiryDate)}
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap">
                                      <div className="text-sm font-medium text-slate-900">
                                        {quotation.products && quotation.products.length > 0
                                          ? `${formatAmount(
                                              quotation.products.reduce((total, item) => {
                                                const taux = parseFloat(item.taux)
                                                const coeff = pricingMultiplier(item)
                                                const t = Number.isFinite(taux) ? taux : 0
                                                const c = Number.isFinite(coeff) ? coeff : 1
                                                return total + t * c
                                              }, 0),
                                              2,
                                            )} €`
                                          : "Non calculé"
                                        }
                                      </div>
                                    </td>
                                    <td className="px-6 py-4 whitespace-nowrap text-center">
                                      <div className="flex items-center justify-center space-x-2">
                                        <Link to={`/devis?quote=${encodeURIComponent(quotation._id)}`} className="rounded-lg px-3 py-2 text-sm font-semibold text-blue-700">Gérer le suivi</Link>
                                        <motion.button
                                          whileHover={{ scale: 1.1 }}
                                          whileTap={{ scale: 0.9 }}
                                          onClick={() => generatePDF(quotation, true)}
                                          disabled={isLoadingQuotation}
                                          className="p-2 text-slate-400 hover:text-blue-600 hover:bg-blue-50 rounded-lg transition-all duration-200 disabled:opacity-50"
                                          title="Voir le PDF"
                                        >
                                          {isLoadingQuotation ? (
                                            <div className="w-4 h-4 border-2 border-blue-600 border-t-transparent rounded-full animate-spin"></div>
                                          ) : (
                                            <Eye className="w-4 h-4" />
                                          )}
                                        </motion.button>
                                        <motion.button
                                          whileHover={{ scale: 1.1 }}
                                          whileTap={{ scale: 0.9 }}
                                          onClick={() => generatePDF(quotation, false)}
                                          disabled={isLoadingQuotation}
                                          className="p-2 text-slate-400 hover:text-green-600 hover:bg-green-50 rounded-lg transition-all duration-200 disabled:opacity-50"
                                          title="Télécharger PDF"
                                        >
                                          {isLoadingQuotation ? (
                                            <div className="w-4 h-4 border-2 border-green-600 border-t-transparent rounded-full animate-spin"></div>
                                          ) : (
                                            <Download className="w-4 h-4" />
                                          )}
                                        </motion.button>
                                      </div>
                                    </td>
                                  </motion.tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="px-6 py-12 text-center">
                            <div className="flex flex-col items-center">
                              <FileText className="w-12 h-12 text-slate-300 mb-4" />
                              <h3 className="text-lg font-medium text-slate-900 mb-2">Aucun devis</h3>
                              <p className="text-slate-500">Commencez par créer un devis pour ce client</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </motion.div>
                  )}

                  {/* Financial/Atradius Tab */}
                  {section === "financial" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-4"
                    >
                      <div className="flex items-center justify-between">
                        <ClientTabHeading title="Couverture Atradius" description="Consultez la couverture financière et les demandes de cote du client." />
                        <motion.button
                          whileHover={{ scale: 1.02 }}
                          whileTap={{ scale: 0.98 }}
                          onClick={() => setIsAskAtradius(true)}
                          className="flex items-center space-x-2 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg transition-colors duration-200"
                        >
                          <Plus className="w-4 h-4" />
                          <span>Demander une cote</span>
                        </motion.button>
                      </div>

                      <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
                        {cover ? (
                          <div className="overflow-x-auto">
                            <table className="min-w-full divide-y divide-slate-200">
                              <thead className="bg-slate-50">
                                <tr>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Date demande
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Type
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Montant demandé
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Montant accordé
                                  </th>
                                  <th className="px-6 py-4 text-left text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    Facture en cours
                                  </th>
                                  <th className="px-6 py-4 text-center text-xs font-medium text-slate-500 uppercase tracking-wider">
                                    État
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="bg-white">
                                <tr>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                                    {formatDate(cover._doc?.decisionDate)}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                                    {cover._doc?.coverType || "Non renseigné"}
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                                    {formatAmount(cover._doc?.creditLimitApplicationAmountInPolicyCurrency)} €
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-slate-900">
                                    {formatAmount(cover._doc?.totalDecision?.decisionAmtInPolicyCurrency)} €
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-sm text-slate-900">
                                    {formatAmount(cover.montantNonFacture, 2)} €
                                  </td>
                                  <td className="px-6 py-4 whitespace-nowrap text-center">
                                    {isAtradiusRefused(cover) ? (
                                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-red-100 text-red-800">
                                        <AlertCircle className="w-3 h-3 mr-1" />
                                        Refusée
                                      </span>
                                    ) : cover.montantNonFacture <= cover._doc?.totalDecision?.decisionAmtInPolicyCurrency ? (
                                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-green-100 text-green-800">
                                        <CheckCircle2 className="w-3 h-3 mr-1" />
                                        OK
                                      </span>
                                    ) : (
                                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-orange-100 text-orange-800">
                                        <Clock className="w-3 h-3 mr-1" />
                                        À revoir
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        ) : (
                          <div className="px-6 py-12 text-center">
                            <div className="flex flex-col items-center">
                              <Shield className="w-12 h-12 text-slate-300 mb-4" />
                              <h3 className="text-lg font-medium text-slate-900 mb-2">Aucune couverture Atradius</h3>
                              <p className="text-slate-500">Demandez une cote pour ce client</p>
                            </div>
                          </div>
                        )}
                      </div>
                    </motion.div>
                  )}

                  {/* Events Tab */}
                  {section === "event" && <ClientHistory client={client} />}

                  {/* Files Tab */}
                  {section === "file" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-4"
                    >
                      <ClientDocuments client={client} />
                    </motion.div>
                  )}

                  {/* Comments Tab */}
                  {section === "commentaire" && (
                    <motion.div
                      initial={{ opacity: 0, y: 20 }}
                      animate={{ opacity: 1, y: 0 }}
                      className="space-y-4"
                    >
                      <ClientComment client={client} clients={clients} setClients={setClients} />
                    </motion.div>
                  )}
                </div>
              </div>
            </div>

            {/* Modals */}
            {isCreatePldContract && (
              <CreateContract
                client={client}
                qualifications={clientQualifications}
                chantiers={clientChantiers}
                isCreateContract={isCreatePldContract}
                setIsCreateContract={setIsCreatePldContract}
              />
            )}

            {isAskAtradius && (
              <Modal open={isAskAtradius} width={560} centered footer={null} onCancel={() => { if (!isLoadingAtradius) setIsAskAtradius(false); }} keyboard={!isLoadingAtradius} maskClosable={!isLoadingAtradius} closable={!isLoadingAtradius} title={<div className="flex items-center gap-3 pr-6"><div className="rounded-xl bg-blue-50 p-3 text-blue-700"><Shield size={22} /></div><div><h2 className="text-xl font-semibold text-slate-900">Demander une cote Atradius</h2><p className="mt-1 text-sm font-normal text-slate-500">Couverture financière du client</p></div></div>}>
                <form onSubmit={askAtradius} className="mt-6">
                  <div className="rounded-xl border border-slate-200 bg-slate-50 p-4"><p className="font-semibold text-slate-900">{client.companyName || client.denomination}</p><p className="mt-2 text-xs text-slate-500">SIRET : {client.siret || "Non renseigné"}</p><p className="mt-1 text-xs text-slate-500">{[client.postCode, client.town].filter(Boolean).join(" ")}</p></div>
                  <div className="mt-4 grid grid-cols-2 gap-3">
                    <div className="rounded-xl border border-blue-100 bg-blue-50 p-4">
                      <p className="text-xs font-medium text-blue-800">Cote actuellement accordée</p>
                      <p className="mt-2 text-lg font-semibold text-blue-950">{cover?._doc?.totalDecision?.decisionAmtInPolicyCurrency != null ? `${formatAmount(cover._doc.totalDecision.decisionAmtInPolicyCurrency, 2)} €` : "—"}</p>
                      {cover?._doc?.decisionDate && <p className="mt-1 text-xs text-blue-700">Décision du {formatDate(cover._doc.decisionDate)}</p>}
                    </div>
                    <div className="rounded-xl border border-slate-200 bg-slate-50 p-4">
                      <p className="text-xs font-medium text-slate-600">Encours</p>
                      <p className="mt-2 text-lg font-semibold text-slate-900">{cover?.montantNonFacture != null ? `${formatAmount(cover.montantNonFacture, 2)} €` : "—"}</p>
                    </div>
                  </div>
                  <div className="mt-5"><label htmlFor="atradius-amount" className="mb-2 block text-sm font-medium text-slate-700">Montant de couverture demandé <span className="text-blue-600">*</span></label><div className="relative"><input id="atradius-amount" type="number" inputMode="numeric" min="1" step="1" required disabled={isLoadingAtradius} value={amount} onChange={e => setAmount(e.target.value)} placeholder="Ex. : 5000" aria-describedby="atradius-amount-help" className="h-12 w-full rounded-lg border border-slate-200 bg-slate-50 pl-4 pr-12 text-lg font-medium focus:bg-white focus:outline-none focus:ring-2 focus:ring-blue-500 disabled:opacity-60" /><span aria-hidden="true" className="absolute right-4 top-3 text-slate-400">€</span></div><p id="atradius-amount-help" className="mt-2 text-xs text-slate-500">Saisissez un montant en euros, sans centimes.</p></div>
                  {!client.siret && <p role="status" className="mt-4 rounded-lg bg-amber-50 p-3 text-sm text-amber-800">Renseignez le SIRET du client pour envoyer cette demande.</p>}
                  <p className="mt-5 text-sm leading-6 text-slate-500">La réponse et le montant accordé seront consultables dans l’onglet Atradius de cette fiche.</p>
                  <div className="mt-6 flex justify-end gap-2 border-t border-slate-100 pt-5"><button type="button" disabled={isLoadingAtradius} onClick={() => setIsAskAtradius(false)} className="rounded-lg border border-slate-200 px-4 py-2.5 text-sm font-medium text-slate-600 hover:bg-slate-50 disabled:opacity-50">Annuler</button><button type="submit" disabled={isLoadingAtradius || !client.siret} className="inline-flex items-center gap-2 rounded-lg bg-blue-700 px-4 py-2.5 text-sm font-semibold text-white hover:bg-blue-800 disabled:opacity-60">{isLoadingAtradius ? <><Loader2 size={16} className="animate-spin" />Envoi en cours…</> : <><Shield size={16} />Envoyer la demande</>}</button></div>
                </form>
              </Modal>
            )}


            {isCreateQuotation && (
              <CreateQuotationModal
                onCreated={() => loadQuotations(client._id)}
                client={client}
                isCreateQuotation={isCreateQuotation}
                setIsCreateQuotation={setIsCreateQuotation}
              />
            )}
          </motion.div>
          {isOpenCreateContact && (
            <Modal open getContainer={false} zIndex={2000} width={680} centered footer={null}
              styles={{ body: { maxHeight: "75vh", overflowY: "auto", paddingRight: 4 } }}
              onCancel={() => { if (!savingContact) setIsOpenCreateContact(false); }}
              closable={!savingContact} maskClosable={!savingContact} keyboard={!savingContact}
              title={<div className="border-b border-slate-200 pb-5 pr-8"><PageHeading icon="clients" level={2} title={editingContactIndex === null ? "Ajouter un contact" : "Modifier le contact"} description={client.companyName || client.denomination} /></div>}
              closeIcon={<X size={20} className="text-slate-400" />}>
              <p className="mt-5 text-sm text-slate-500">Renseignez ses coordonnées et choisissez les documents qu’il peut gérer.</p>
              {contactForm}
            </Modal>
          )}
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default ClientDetail;
